import './navbar-badge.scss';

interface IProps {
  isSidebarExpanded: boolean;
  count: number;
  badgeMaxCount?: number;
}

const NavbarBadge: React.FC<IProps> = ({
  isSidebarExpanded,
  count,
  badgeMaxCount = 9999
}) => {
  if (count === 0) return null;
  return (
    <span
      className={`navbar-badge ${isSidebarExpanded ? '' : 'navbar-badge--collapsed'}`}
    >
      {Math.min(count, badgeMaxCount) + (count > badgeMaxCount ? '+' : '')}
    </span>
  );
};

export default NavbarBadge;
